import React from "react";
import Axios from "axios";
import { useQuery } from "react-query";
import { Modal } from "antd";

const formatHistoryValue = (value) => {
  if (Array.isArray(value)) return value.length ? value.join(", ") : "-";
  return value === null || value === undefined || value === "" ? "-" : String(value);
};

const ModalNonPublishableKeywordHistory = ({ recordId, onClose }) => {
  const { data, isLoading } = useQuery(
    ["nonPublishableKeywordHistory", recordId],
    () =>
      Axios.get(`/api/v1/non_publishable_keywords/${recordId}/history`).then(
        (res) => res.data?.data || []
      ),
    { enabled: !!recordId }
  );

  const history = data || [];

  return (
    <Modal
      title="Changes history"
      open={!!recordId}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      {isLoading ? (
        <p>Loading...</p>
      ) : history.length === 0 ? (
        <p>No changes history available.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #f0f0f0", textAlign: "left" }}>
              <th style={{ padding: "8px 12px" }}>Field</th>
              <th style={{ padding: "8px 12px" }}>From</th>
              <th style={{ padding: "8px 12px" }}>To</th>
              <th style={{ padding: "8px 12px" }}>Changed at</th>
              <th style={{ padding: "8px 12px" }}>Changed by</th>
            </tr>
          </thead>
          <tbody>
            {history.map((entry, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #f0f0f0" }}>
                <td style={{ padding: "8px 12px" }}>{entry.field || "-"}</td>
                <td style={{ padding: "8px 12px" }}>{formatHistoryValue(entry.from)}</td>
                <td style={{ padding: "8px 12px" }}>{formatHistoryValue(entry.to)}</td>
                <td style={{ padding: "8px 12px" }}>{entry.changed_at || "-"}</td>
                <td style={{ padding: "8px 12px" }}>{entry.changed_by || "System"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Modal>
  );
};

export default ModalNonPublishableKeywordHistory;
